module.exports = __webpack_public_path__ + "img/icon-document-asset.15893b25.svg";